<h2 mat-dialog-title data-testid="event-detail-title">{{ event.title }}</h2>

<mat-dialog-content data-testid="event-detail-content">
  <div class="ed-row" data-testid="event-detail-date">
    <mat-icon>calendar_today</mat-icon>
    <span>{{ event.day + 'T00:00:00' | date: 'MMMM d, y' }}</span>
  </div>

  <div class="ed-row" data-testid="event-detail-time">
    <mat-icon>schedule</mat-icon>
    <span>{{ timeLabel(event.start_time, event.end_time) }}</span>
  </div>

  @if (event.place) {
    <div class="ed-row" data-testid="event-detail-location">
      <mat-icon>location_on</mat-icon>
      <span>{{ event.place }}</span>
    </div>
  }

  @if (event.description) {
    <p class="ed-description" data-testid="event-detail-description">{{ event.description }}</p>
  }

  @if (attendees) {
    <div class="ed-attendees">
      <details class="ed-attendees-section">
        <summary class="ed-attendees-summary">
          Attending <span class="ed-count">{{ attendees.attending.length }}</span>
        </summary>
        @if (attendees.attending.length > 0) {
          @for (student of attendees.attending; track student.user_id) {
            <div class="ed-attendee-item">
              {{ student.first_name }} {{ student.last_name }}
              <span class="ed-grade">Grade {{ student.grade_level }}</span>
            </div>
          }
        } @else {
          <p class="ed-empty">No students attending yet.</p>
        }
      </details>

      <details class="ed-attendees-section">
        <summary class="ed-attendees-summary">
          Not Attending <span class="ed-count">{{ attendees.notAttending.length }}</span>
        </summary>
        @if (attendees.notAttending.length > 0) {
          @for (student of attendees.notAttending; track student.user_id) {
            <div class="ed-attendee-item">
              {{ student.first_name }} {{ student.last_name }}
              <span class="ed-grade">Grade {{ student.grade_level }}</span>
            </div>
          }
        } @else {
          <p class="ed-empty">No students have declined.</p>
        }
      </details>

      <details class="ed-attendees-section">
        <summary class="ed-attendees-summary">
          No Response <span class="ed-count">{{ attendees.noResponse.length }}</span>
        </summary>
        @if (attendees.noResponse.length > 0) {
          @for (student of attendees.noResponse; track student.user_id) {
            <div class="ed-attendee-item">
              {{ student.first_name }} {{ student.last_name }}
              <span class="ed-grade">Grade {{ student.grade_level }}</span>
            </div>
          }
        } @else {
          <p class="ed-empty">Everyone has responded.</p>
        }
      </details>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" data-testid="event-detail-close-btn">Close</button>
  @if (isStudent) {
    <button
      mat-flat-button
      [class]="response === 'confirmed' ? 'ed-choice ed-choice-attending' : 'ed-choice'"
      [attr.aria-pressed]="response === 'confirmed'"
      (click)="respond('confirmed')"
      data-testid="event-detail-attend-btn"
    >
      Attending
    </button>
    <button
      mat-flat-button
      [class]="response === 'declined' ? 'ed-choice ed-choice-declined' : 'ed-choice'"
      [attr.aria-pressed]="response === 'declined'"
      (click)="respond('declined')"
      data-testid="event-detail-decline-btn"
    >
      Not Attending
    </button>
  }
  @if (isCounselor && isOwner) {
    <button mat-flat-button (click)="openEdit()" data-testid="event-detail-edit-btn">Edit</button>
  }
</mat-dialog-actions>
